import React, { memo, type ReactElement } from 'react';
import {
  Box,
  Button,
  Illustration,
  type IllustrationKind,
  Typography,
} from '@saviynt/design-system';

import { useInvertedLocalize } from '../../hooks';

import './SodMessage.css';

interface SodMessageProps {
  isSearchActive: boolean;
  isFilterActive: boolean;
  handleFilterClearBtn: () => void;
  defaultTitle?: string;
  defaultMessage?: string;
}

/**
 * SodMessage
 */
function SodMessage({
  isSearchActive,
  isFilterActive,
  handleFilterClearBtn,
  defaultTitle,
  defaultMessage,
}: SodMessageProps): ReactElement {
  const l = useInvertedLocalize();

  if (isSearchActive || isFilterActive) {
    return (
      <Box tag='div' className='Sod-Message-illustrationWrapper'>
        <Illustration kind={'Empty' as IllustrationKind} />{' '}
        {/* eslint-disable-line @typescript-eslint/no-unsafe-assignment */}
        <Typography kind='h1' desktop='h1-d' mobile='h1-d'>
          {l('No Matching Results Found')}
        </Typography>
        <Typography
          kind='body1'
          desktop='body1-d'
          mobile='body1-d'
          className='Sod-Message-illustrationMessage'>
          {isSearchActive
            ? l('Try clearing the search or check back later.')
            : l('Try updating the filters or check back later.')}
        </Typography>
        {isFilterActive && (
          <Button type='button' kind='filled' onClick={handleFilterClearBtn}>
            {l('Clear Filters')}
          </Button>
        )}
      </Box>
    );
  }

  return (
    <Box tag='div' className='Sod-Message-illustrationWrapper--isOpen'>
      <Illustration kind={'Empty' as IllustrationKind} />{' '}
      {/* eslint-disable-line @typescript-eslint/no-unsafe-assignment */}
      <Typography kind='h1' desktop='h1-d' mobile='h1-d'>
        {l(defaultTitle ?? 'No Results Found!')}
      </Typography>
      {defaultMessage && (
        <Typography kind='body1' desktop='body1-d' mobile='body1-d'>
          {l(defaultMessage)}
        </Typography>
      )}
    </Box>
  );
}

SodMessage.defaultProps = {
  defaultTitle: 'No Results Found!',
  defaultMessage: null,
};

export default memo(SodMessage);
